import { render, staticRenderFns } from "./AnnotatorNewEdit.vue?vue&type=template&id=9fd41216&scoped=true&"
import script from "./AnnotatorNewEdit.vue?vue&type=script&lang=js&"
export * from "./AnnotatorNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd41216",
  null
  
)

export default component.exports